import isObject from "../../common-utils/object/isObject.util.js";
/**
 * Checks whether the provided input is strictly an object or not, serving as a type guard.
 * @param input unknown
 * @returns boolean
 */
export const isStrictObjectUtil = (input) => isObject(input) && Object.prototype.toString.call(input) === "[object Object]";
export default isStrictObjectUtil;
